module.exports = __webpack_public_path__ + "static/Audit-1-be06a6166d0ffe454f1fb7c5230b8a15.svg";